import { BadgeDollarSign } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { PRICING, scrollToId } from "@/lib/site";

export const Pricing = () => (
  <section id="pricing" data-testid="pricing-section" className="relative bg-paper text-[#0F172A] py-16 sm:py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <Eyebrow light>Mobile Service Pricing Schedule</Eyebrow>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none text-[#0F172A]">
            Straight pricing.<br />No shop markup.
          </h2>
          <div className="flex items-center gap-3 bg-white border border-slate-200 rounded-sm px-5 py-4 shadow-sm">
            <BadgeDollarSign className="w-8 h-8 text-[#3E7C24]" strokeWidth={1.75} />
            <div>
              <p className="font-display font-bold uppercase text-xl leading-none">$100 Call-Out Base</p>
              <p className="text-sm text-slate-500 mt-1">Flat dispatch — travel & vehicle setup covered</p>
            </div>
          </div>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-6">
        {PRICING.map((group, gi) => (
          <Reveal key={group.id} delay={(gi % 2) * 0.12}>
            <div
              data-testid={`pricing-card-${group.id}`}
              className="bg-white border border-slate-200 rounded-sm shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 overflow-hidden h-full"
            >
              <div className="px-7 py-5 border-b border-slate-100 flex items-baseline justify-between gap-4 flex-wrap">
                <h3 className="font-display font-bold uppercase text-2xl tracking-tight">
                  <span className="font-mono2 text-xs text-[#3E7C24] mr-3 align-middle">{String(gi + 1).padStart(2, "0")}</span>
                  {group.title}
                </h3>
                <span className="font-mono2 text-[10px] tracking-[0.2em] uppercase text-slate-400">{group.note}</span>
              </div>
              <ul>
                {group.rows.map((row, ri) => (
                  <li
                    key={row.name}
                    data-testid={`pricing-row-${group.id}-${ri}`}
                    className="px-7 py-4 flex items-start justify-between gap-6 border-b border-slate-50 last:border-0 hover:bg-slate-50 transition-colors"
                  >
                    <div>
                      <p className="font-semibold text-sm">{row.name}</p>
                      <p className="text-xs text-slate-500 mt-0.5">{row.detail}</p>
                    </div>
                    <span className="font-mono2 text-sm font-bold text-[#3E7C24] whitespace-nowrap pt-0.5">{row.price}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-10 flex flex-wrap items-center justify-between gap-6 bg-[#22262B] text-white rounded-sm px-7 py-6">
        <p className="text-sm text-slate-300 max-w-xl">
          All prices confirmed upfront before work begins. Off-site service and vehicle pick-up available for larger jobs.
        </p>
        <button
          data-testid="pricing-book-btn"
          onClick={() => scrollToId("#booking")}
          className="bg-ember text-obsidian font-display font-bold uppercase tracking-wider px-7 py-3 rounded-sm hover:bg-[#9BE873] hover:shadow-[0_0_28px_rgba(132,220,90,0.4)] transition-all duration-200"
        >
          Book at These Rates
        </button>
      </Reveal>
    </div>
  </section>
);
